import { render, staticRenderFns } from "./EditorList.vue?vue&type=template&id=ccc6c892&scoped=true"
import script from "./EditorList.vue?vue&type=script&lang=js"
export * from "./EditorList.vue?vue&type=script&lang=js"
import style0 from "./EditorList.vue?vue&type=style&index=0&id=ccc6c892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc6c892",
  null
  
)

export default component.exports